const ACCENT_CLASS = 'ch-text-block__accent-phrase';
const TARGET_SELECTOR = '[data-ch-accent-phrases]';

function escapeRegExp(value) {
  return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function accentifyTextNode(node, matcher) {
  const text = node.textContent ?? '';

  if (!text.trim()) return;

  matcher.lastIndex = 0;
  let match = matcher.exec(text);

  if (!match) return;

  const fragment = document.createDocumentFragment();
  let lastIndex = 0;

  while (match) {
    const [matchedText] = match;
    const matchIndex = match.index;

    if (matchIndex > lastIndex) {
      fragment.append(document.createTextNode(text.slice(lastIndex, matchIndex)));
    }

    const accent = document.createElement('span');
    accent.className = ACCENT_CLASS;
    accent.textContent = matchedText;
    fragment.append(accent);

    lastIndex = matchIndex + matchedText.length;
    match = matcher.exec(text);
  }

  if (lastIndex < text.length) {
    fragment.append(document.createTextNode(text.slice(lastIndex)));
  }

  node.replaceWith(fragment);
}

function applyAccentPhrases(target) {
  if (!(target instanceof Element) || target.dataset.chAccentPrepared === 'true') return;

  const phrases = (target.getAttribute('data-ch-accent-phrases') || '')
    .split(/\s*,\s*|\r?\n/)
    .map((phrase) => phrase.trim())
    .filter(Boolean)
    .sort((a, b) => b.length - a.length);

  if (!phrases.length) {
    target.dataset.chAccentPrepared = 'true';
    return;
  }

  const matcher = new RegExp(`(${phrases.map(escapeRegExp).join('|')})`, 'gi');

  const walk = (node) => {
    if (node.nodeType === Node.TEXT_NODE) {
      accentifyTextNode(node, matcher);
      return;
    }

    if (!(node instanceof Element)) return;
    if (node.classList.contains(ACCENT_CLASS)) return;

    [...node.childNodes].forEach((child) => walk(child));
  };

  walk(target);
  target.dataset.chAccentPrepared = 'true';
}

function scanAccentPhrases(root = document) {
  const targets = root instanceof Element && root.matches(TARGET_SELECTOR)
    ? [root]
    : [...root.querySelectorAll(TARGET_SELECTOR)];

  targets.forEach(applyAccentPhrases);
}

scanAccentPhrases();

document.addEventListener('DOMContentLoaded', () => scanAccentPhrases());
document.addEventListener('shopify:section:load', (event) => scanAccentPhrases(event.target));
